import './ui/community.css';

/**
 * Marks the document as the community shell: switches the palette scope
 * (community.css is keyed on data-edition) and drops the enterprise `dark`
 * class the index.html ships with.
 *
 * The two typefaces are self-hosted (public/fonts, decided 2026-09-10): no
 * request leaves the deployment for a font, and an air-gapped site renders
 * the design too. Declared in ui/fonts.css, which main.tsx loads for both
 * editions (the viewer draws in them in either), and preloaded by index.html,
 * so they are there before anything is drawn.
 */
export function enterCommunityShell(): void {
  const html = document.documentElement;
  html.dataset.edition = 'community';
  html.classList.remove('dark');
}
